var map = {
	"./agent.svg": "1586",
	"./assistant.svg": "d919",
	"./assistant2.svg": "df84",
	"./bankcard.svg": "b8ec",
	"./cms.svg": "af44",
	"./coupon.svg": "e24d",
	"./distribution.svg": "8f9e",
	"./example.svg": "30c3",
	"./express.svg": "ab2b",
	"./eye.svg": "4df5",
	"./form.svg": "eb1b",
	"./home.svg": "6bbe",
	"./international.svg": "17df",
	"./language.svg": "2580",
	"./member.svg": "daf4",
	"./merchandise.svg": "f1d5",
	"./notice.svg": "fc99",
	"./order.svg": "11ff",
	"./password.svg": "2a3d",
	"./promotion.svg": "2025",
	"./shop.svg": "5def",
	"./statistics.svg": "a1cf",
	"./stock.svg": "2466",
	"./table.svg": "47f1",
	"./transaction.svg": "f062",
	"./tree.svg": "93cd",
	"./user.svg": "b3b5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";